import { create } from 'zustand';
import { applyTheme, storeTheme } from '../lib/theme.js';

/**
 * Chapters & Co is permanently set to the Canvas Paper edition with black letters.
 * The theme store preserves the interface for consumers (e.g. Logo) while keeping
 * the theme locked to 'light'. No day/night toggle or option exists.
 */
export const useThemeStore = create(() => ({
  preference: 'light',
  theme: 'light',
  setPreference() {},
  toggle() {},
}));

if (typeof document !== 'undefined') {
  storeTheme();
  applyTheme();
}

export const selectTheme = () => 'light';
export const selectToggleTheme = (s) => s.toggle;

export default useThemeStore;
